import { render, staticRenderFns } from "./Roadmap.vue?vue&type=template&id=3b94341e&scoped=true"
import script from "./Roadmap.vue?vue&type=script&lang=js"
export * from "./Roadmap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b94341e",
  null
  
)

export default component.exports